import { Logger } from 'logger';
import * as Layouts from 'openfin-layouts';

const debugLog = Logger.create('WorkspaceUtils.ts')

export class LayoutService {
  public static instance: LayoutService;

  public static getInstance() {
    if (!LayoutService.instance) {
      LayoutService.instance = new LayoutService();
    }
    return LayoutService.instance;
  }

  constructor() {
    Layouts.workspaces.setRestoreHandler(e => false);
    Layouts.workspaces.setGenerateHandler(() => {
      return {};
    });
    Layouts.workspaces.ready();
  }

  public persistWindows = async (workspaceName: string) => {
    const workspaceObject = await Layouts.workspaces.generate();
    localStorage.setItem(workspaceName, JSON.stringify(workspaceObject));

    return workspaceObject;
  };

  public closeAllWindows = async () => {
    const ofApp = await (window as any).fin.Application.getCurrent();
    const openWindows = await ofApp.getChildWindows();
    debugLog(`openWindows: ${openWindows}`);
    const filteredOpenWindows = openWindows.filter((win: any) => win.identity.name !== 'workspaces');
    debugLog(`filteredOpenWindows: ${filteredOpenWindows}`);
    filteredOpenWindows.map((win: any) => win.close());
  }

  public hydrateWindows = async (workspaceName: string) => {
    const persistedData = localStorage.getItem(workspaceName);
    debugLog(`persistedData: ${persistedData}`);
    if (persistedData !== null) {
      debugLog('found old state restoring using it');
      const workspaceObject = JSON.parse(persistedData);
      await this.closeAllWindows();
      // close all open windows besides launcher and ...
      const ofApp = await (window as any).fin.Application.getCurrent();
      await ofApp.getChildWindows();

      // implement custom restore handler iterating workspace object
      if (workspaceObject.apps[0]) {
        const workspaceWindows = workspaceObject.apps[0].childWindows.filter((win: any) => win.name !== 'menu');

        workspaceWindows.forEach(async (childWindow: any) => {
          debugLog('here');
          await new (window as any).fin.desktop.Window({ ...childWindow, autoShow: true });
        });
      }
    } else {
      // await Layouts.workspaces.restore();
    }
  };
}
